import type { ArchiveJob, ArchiveStore } from "./mediaTypes";

const open = (): Promise<IDBDatabase> => new Promise((resolve, reject) => {
  if (typeof indexedDB === "undefined") { reject(new Error("Local archival storage unavailable")); return; }
  const request = indexedDB.open("hkp-original-archives-v1", 1);
  request.onupgradeneeded = () => request.result.createObjectStore("archives", { keyPath: "mediaId" });
  request.onerror = () => reject(new Error("Local archival storage unavailable"));
  request.onblocked = () => reject(new Error("Close another HKP tab to update local upload storage"));
  request.onsuccess = () => resolve(request.result);
});

async function transaction<T>(mode: IDBTransactionMode,
  execute: (store: IDBObjectStore) => IDBRequest<T>): Promise<T> {
  const db = await open();
  return new Promise<T>((resolve, reject) => {
    const tx = db.transaction("archives", mode);
    const request = execute(tx.objectStore("archives"));
    let result: T;
    request.onsuccess = () => { result = request.result; };
    tx.oncomplete = () => { db.close(); resolve(result); };
    tx.onerror = tx.onabort = () => { db.close(); reject(new Error("Could not persist original upload")); };
  });
}
export const archiveStore: ArchiveStore = {
  put: async job => { await transaction("readwrite", store => store.put(job)); },
  get: id => transaction("readonly", store => store.get(id) as IDBRequest<ArchiveJob | undefined>),
  list: () => transaction("readonly", store => store.getAll() as IDBRequest<ArchiveJob[]>),
  remove: async id => { await transaction("readwrite", store => store.delete(id)); },
};
